import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class WalletEarningsPaginated {
  @Type(() => WalletEarningItem)
  items: WalletEarningItem[];

  @Expose({ name: 'next_page_url' })
  nextPageUrl?: string;

  @Expose({ name: 'bonus_labels' })
  bonusLabels?: Record<string, string>;

  @Expose({ name: 'bonus_types' })
  bonusTypes?: string[];

  constructor(
    items: WalletEarningItem[],
    nextPageUrl?: string,
    bonusLabels?: Record<string, string>,
    bonusTypes?: string[]
  ) {
    this.items = items;
    this.nextPageUrl = nextPageUrl;
    this.bonusLabels = bonusLabels;
    this.bonusTypes = bonusTypes;
  }

  get cursor(): string | null {
    return this.nextPageUrl
      ? new URL(this.nextPageUrl).searchParams.get('cursor') || null
      : null;
  }

  static fromJson(json: Record<string, any>): WalletEarningsPaginated {
    return plainToInstance(WalletEarningsPaginated, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}

export class WalletEarningItem {
  id: number;

  @Expose({ name: 'amount_generated' })
  amount: string;

  tax: string;

  @Expose({ name: 'service_charge' })
  serviceCharge: string;

  @Expose({ name: 'bonus_type' })
  type: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  dateCreated: Date;

  level?: number;

  @Expose({ name: 'from_user' })
  fromUser?: string;

  @Expose({ name: 'rank_name' })
  rankName?: string;

  constructor(
    id: number,
    amount: string,
    tax: string,
    serviceCharge: string,
    type: string,
    dateCreated: Date,
    level?: number,
    fromUser?: string,
    rankName?: string
  ) {
    this.id = id;
    this.amount = amount;
    this.tax = tax;
    this.serviceCharge = serviceCharge;
    this.type = type;
    this.dateCreated = dateCreated;
    this.level = level;
    this.fromUser = fromUser;
    this.rankName = rankName;
  }

  static fromJson(json: Record<string, any>): WalletEarningItem {
    return plainToInstance(WalletEarningItem, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
